import http from "@/settings/apiSettings";

export interface BrandingFeature {
  icon: string;
  color: string;
  title: string;
  desc: string;
}

export interface Branding {
  slug: string;
  color?: string;
  logoText?: string;
  logoUrl?: string;
  title?: string;
  subtitle?: string;
  active?: boolean;
  features: BrandingFeature[];
}

/**
 * Slug-ul clientului = primul segment din hostname (subdomeniu).
 * Pentru testare pe localhost se poate forța cu ?brand=portalhr.
 */
export function resolveSlug(): string {
  const override = new URLSearchParams(window.location.search).get("brand");
  if (override) return override.trim().toLowerCase();

  const host = window.location.hostname.toLowerCase();
  // localhost / IP direct -> nu există subdomeniu real -> tratăm ca „demo”.
  if (host === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return "demo";

  return host.split(".")[0];
}

// Backend-ul folosește PreserveCaseNamingPolicy => JSON PascalCase. Normalizăm la interfața locală.
function normalize(d: any): Branding {
  const feats = Array.isArray(d?.Features ?? d?.features) ? (d.Features ?? d.features) : [];
  return {
    slug: d?.Slug ?? d?.slug ?? "",
    color: d?.Color ?? d?.color,
    logoText: d?.LogoText ?? d?.logoText,
    logoUrl: d?.LogoUrl ?? d?.logoUrl,
    title: d?.Title ?? d?.title,
    subtitle: d?.Subtitle ?? d?.subtitle,
    features: feats.map((f: any) => ({
      icon: f?.Icon ?? f?.icon ?? "",
      color: f?.Color ?? f?.color ?? "",
      title: f?.Title ?? f?.title ?? "",
      desc: f?.Desc ?? f?.desc ?? "",
    })),
  };
}

class BrandingService {
  /** Întoarce branding-ul pentru slug-ul curent, sau null (front-ul cade pe valorile implicite). */
  async get(slug: string = resolveSlug()): Promise<Branding | null> {
    try {
      const r = await http.client.get(`/Branding/${slug}`);
      return normalize(r.data);
    } catch {
      // slug necunoscut (404) sau backend indisponibil -> fallback pe branding-ul implicit din LoginView.
      return null;
    }
  }
}

export default new BrandingService();
